// extracted by mini-css-extract-plugin
export var categorySection = "ProjectCategoryPage-module--categorySection--b3e3a";
export var projectSearch = "ProjectCategoryPage-module--projectSearch--18c4e";